import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, RelatedProducts } from '~/app/tracking/feld-m-types';
import { CatalogItemType, FeatureOrPackage } from '~/graphql/types';

export type ViewChangeEventParams = {
	eventName: string;
	componentName?: string;
	relatedProducts?: RelatedProducts;
	item?: FeatureOrPackage | CatalogItemType['trimline'] | CatalogItemType['driveTrain'];
	pageID?: string;
};
export class ViewChangeEvent extends BaseEvent {
	constructor({ eventName, componentName = '', relatedProducts, pageID }: ViewChangeEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.ViewChange,
				eventName,
			},
			attributes: {
				componentName,
				...(relatedProducts && { relatedProducts }),
			},
			...(pageID && {
				additionalObjects: {
					componentInfo: {
						componentID: 7,
					},
					attributes: {
						implementer: 1,
						version: '1.0.0',
					},
					page: {
						pageInfo: {
							pageID,
						},
					},
				},
			}),
		});
	}
}
